import { Component, inject } from '@angular/core';
import { NgHttpLoaderModule } from 'ng-http-loader';
import { ConfirmationService } from 'primeng/api';
import { environment } from '../environments/environment';
import { AlphaSharedModule } from './alpha.shared.module';
import { LoaderComponent } from './components/base-layout/loader/loader.component';
import { AcPaletteService } from './components/ui-builder/shared/services/ac-palette.service';
import { BranchStateService } from './services/branch-state.service';

@Component({
    selector: 'app-root',
    standalone: true,
    imports: [AlphaSharedModule, NgHttpLoaderModule],
    providers: [ConfirmationService],
    templateUrl: './app.component.html',
})
export class AppComponent {
    title = 'alpha-workflow-studio';
    loaderComponent = LoaderComponent;
    statusIcons: any = {
        info: { src: 'assets/icons/status-info.svg' },
        success: { src: 'assets/icons/status-success.svg' },
        warn: { src: 'assets/icons/status-warn.svg' },
        error: { src: 'assets/icons/status-error.svg' },
    };
    // reference: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Classes/Static_initialization_blocks
    constructor() {
        window.isAWSrunning = true;
        window.environments = environment;
        inject(BranchStateService); // Initialize early for navigation interception
        const paletteService = inject(AcPaletteService);
        const paletteListener = (e: any) => {
            paletteService.paletteList = e.detail.paletteList;
        };
        window.addEventListener('alpha-ui-builder:palette-update', paletteListener);
    }
}
